/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useConfig } from "../../../context/ConfigContext.js"

async function downloadAllZip(apiURL, apiKey) {
  try {
    const res = await fetch(`${apiURL}`, {
      headers: { "Api-Key": apiKey },
      credentials: "include"
    });

    if (!res.ok) {
      alert("Could not download ZIP");
      return;
    }

    const blob = await res.blob();
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "raffle_tickets_all.zip";
    link.click();

    URL.revokeObjectURL(url);
  } catch (err) {
    console.error(err);
  }
}


/* ---------------------------------------- */
/* Audit Log tab                            */
/* ---------------------------------------- */

export default function RaffleAudit() {
  const [page, setPage] = useState(1);
  const [entries, setEntries] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const { config } = useConfig()
  const apiUrl = config.REACT_APP_RAFFLEAUDIT
  const apiKey = config.REACT_APP_ADMIN_KEY
  const apiUrlDownload = config.REACT_APP_RAFFLEDOWNLOADALL

  console.log(apiUrl)

  const loadPage = async (p) => {
    setLoading(true);
    try {
      const res = await fetch(`${apiUrl}?page=${p}`, {
        headers: { "Api-Key": apiKey }, credentials: "include",
      });
      if (!res.ok) throw new Error("Failed to load audit log");
      const data = await res.json();
      setEntries(data.entries || data.rows || []);
      setTotalPages(data.totalPages || 1);
      setPage(p);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPage(1);
  }, [apiUrl, apiKey]);

  return (
    <div className="raffle-section">
                <button onClick={downloadAllZip} className="btn-primary">
            Download ALL PDFs (ZIP)
            </button>
      <div className="raffle-audit-list">
        {loading && <p className="muted small">Loading…</p>}
        {!loading && entries.length === 0 && (
          <p className="muted small">No raffle entries yet.</p>
        )}

        {entries.map((e) => (
          <div key={e._id} className="raffle-audit-row">
            <div>
              <strong>{e.name}</strong>{" "}
              <span className="muted small">({e.email})</span>
            </div>
            <div className="muted small">
              Tickets: {e.ticketNumbers?.length ?? 0} •{" "}
              {new Date(e.createdAt).toLocaleString()}
            </div>
          </div>
        ))}
      </div>

      <div className="raffle-audit-pagination">
        <button
          className="btn ghost"
          disabled={page <= 1}
          onClick={() => loadPage(page - 1)}
        >
          Prev
        </button>
        <span className="muted small">
          Page {page} / {totalPages}
        </span>
        <button
          className="btn ghost"
          disabled={page >= totalPages}
          onClick={() => loadPage(page + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
}